import System from "./system";
import {isArray, isString} from "underscore";
import ExternalSales from "./RoleAndPermission/ExternalSales";
import Fsp from "./RoleAndPermission/Fsp";
import SuperAdmin from "./RoleAndPermission/SuperAdmin";
import ZaIsa from "./RoleAndPermission/ZaIsa";
import Ze from "./RoleAndPermission/Ze";
import ZiInter from "./RoleAndPermission/ZiInter";
import ZuPurchaseManager from "./RoleAndPermission/ZuPurchaseManager";
import ZxFieldEngineer from "./RoleAndPermission/ZxFieldEngineer";
import Guest from "./RoleAndPermission/Guest";
import AuthAccountLess from "./RoleAndPermission/AuthAccountLess";
import Zs from "./RoleAndPermission/Zs";
import Zj from "./RoleAndPermission/Zj";

class RoleAndPermission {

    static register = {
        [ExternalSales.avUserInfoName]: ExternalSales.register,
        [Fsp.avUserInfoName]: Fsp.register,
        [SuperAdmin.avUserInfoName]: SuperAdmin.register,
        [ZaIsa.avUserInfoName]: ZaIsa.register,
        [Ze.avUserInfoName]: Ze.register,
        [ZiInter.avUserInfoName]: ZiInter.register,
        [ZuPurchaseManager.avUserInfoName]: ZuPurchaseManager.register,
        [ZxFieldEngineer.avUserInfoName]: ZxFieldEngineer.register,
        [Guest.avUserInfoName]: Guest.register,
        [AuthAccountLess.avUserInfoName]: AuthAccountLess.register,
        [Zj.avUserInfoName]: Zj.register,
        [Zs.avUserInfoName]: Zs.register,
    };

    static loadPermissionBasedOnAuthRole() {
        this.readRoleBasedPermission();
    }

    static readRoleBasedPermission() {
        let r = System.auth('roles');
        let p = {};
        if (r && isArray(r) && r.length > 0) {
            r.map((v) => {
                if (this.register[v] !== undefined && Object.entries(this.register[v]).length > 0) {
                    Object.entries(this.register[v]).map((v_inner) => {
                        p[v_inner[0]] = {
                            slug: v_inner[0]
                        };
                    })
                }
            })
        }
        if (window.all_registered_permissions === undefined) {
            let permissions = {};
            Object.entries(RoleAndPermission.register).map((v) => {
                permissions = {...permissions, ...v[1]}
            });
            window.all_registered_permissions = permissions;
        }
        window.active_permissions = p;
        return p;
    }

    static getMainObjectByPermission(permissionKeySlug) {
        if (window.active_permissions[permissionKeySlug] !== undefined) {
            return true;
        }
        return false;
    }

    static checkGivenPermissionOnLoadedByPermission(permissionKeySlug) {
        let r = {
            status: false,
            render: false,
        };
        if (isString(permissionKeySlug)) {
            let r_s = RoleAndPermission.getMainObjectByPermission(permissionKeySlug);
            if (r_s) {
                r.status = true;
            }
            let p_m = window.all_registered_permissions[permissionKeySlug];
            if (r.status === true && p_m!==undefined) {
                p_m.render = false;
            }
            r = {
                ...r,
                ...p_m
            }
        }
        return r;
    }

    static guestErrorTooltip()
    {
        return "Contact support regarding <br /> access to all features. <br /> <a href='#' style='color:#fff;border:0;outline:0;'>Click here for more information</a>";
    }

    static getGuestErrorForBOMCart()
    {
        return "Request for an "+System.siteName()+" account to access this feature.";
    }
}

export default RoleAndPermission;